import React from "react";
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel } from "@material-ui/core";

interface CheckboxSelectorProps {
  label: string;
  items: string[];
  selectedItems: string[];
  setSelectedItems: (items: string[]) => void;
}

export const CheckboxSelector: React.FC<CheckboxSelectorProps> = ({
  label,
  items,
  selectedItems,
  setSelectedItems,
}) => {
  return (
    <FormControl component="fieldset">
      <FormLabel component="legend">{label}</FormLabel>
      <FormGroup row>
        {items.map(item => (
          <FormControlLabel
            key={item}
            control={
              <Checkbox
                checked={selectedItems.includes(item)}
                onChange={e => {
                  if (e.target.checked) {
                    setSelectedItems([...selectedItems, item]);
                  } else {
                    setSelectedItems(selectedItems.filter(i => i !== item));
                  }
                }}
              />
            }
            label={item.replace("_", " ")}
          />
        ))}
      </FormGroup>
    </FormControl>
  );
};
